import { ChevronRight, Clock, MapPin, User, Phone, IdCard } from 'lucide-react'
import type { Violation } from '../types'
import { formatTimestamp, redactFullName, redactPhone, redactSSN, formatCoordinates } from '../utils'
import './ViolationsPanel.css'

interface ViolationsPanelProps {
  violations: Violation[]
  selectedViolation: Violation | null
  onSelectViolation: (violation: Violation | null) => void
  status: string
}

export function ViolationsPanel({
  violations,
  selectedViolation,
  onSelectViolation,
  status,
}: ViolationsPanelProps) {
  return (
    <div className="violations-panel">
      <div className="panel-header">
        <div className="panel-title">
          <span>VIOLATION LOG</span>
        </div>
        <div className="panel-status">{status}</div>
      </div>

      <div className="violations-content">
        {violations.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">✓</div>
            <div className="empty-text">NO VIOLATIONS RECORDED</div>
            <div className="empty-subtext">NFZ is clear</div>
          </div>
        ) : (
          <ul className="violations-list">
            {violations.map((violation) => (
              <li
                key={`${violation.index}-${violation.id}`}
                className={`violation-item ${selectedViolation?.index === violation.index ? 'selected' : ''}`}
                onClick={() =>
                  onSelectViolation(selectedViolation?.index === violation.index ? null : violation)
                }
              >
                <div className="violation-row violation-row-primary">
                  <ChevronRight
                    size={16}
                    className={`chevron ${selectedViolation?.index === violation.index ? 'open' : ''}`}
                  />
                  <span className="violation-id">ID: {violation.id.slice(0, 8)}</span>
                  <span className="violation-time">
                    <Clock size={12} />
                    {formatTimestamp(violation.timestamp)}
                  </span>
                </div>

                {selectedViolation?.index === violation.index && (
                  <div className="violation-details">
                    <div className="detail-row">
                      <User size={14} />
                      <span className="detail-label">OWNER:</span>
                      <span className="detail-value">
                        {redactFullName(violation.owner_first_name, violation.owner_last_name)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <IdCard size={14} />
                      <span className="detail-label">SSN:</span>
                      <span className="detail-value">{redactSSN(violation.owner_ssn)}</span>
                    </div>
                    <div className="detail-row">
                      <Phone size={14} />
                      <span className="detail-label">PHONE:</span>
                      <span className="detail-value">{redactPhone(violation.owner_phone)}</span>
                    </div>
                    <div className="detail-row">
                      <MapPin size={14} />
                      <span className="detail-label">POSITION:</span>
                      <span className="detail-value">
                        {formatCoordinates(violation.position_x, violation.position_y, violation.position_z)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">DRONE:</span>
                      <span className="detail-value">{violation.drone_id.slice(0, 12)}...</span>
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
